import { render, staticRenderFns } from "./transaction-cost-inquiry.vue?vue&type=template&id=7f878f1f&scoped=true&"
import script from "./transaction-cost-inquiry.vue?vue&type=script&lang=js&"
export * from "./transaction-cost-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./transaction-cost-inquiry.vue?vue&type=style&index=0&id=7f878f1f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f878f1f",
  null
  
)

export default component.exports